import styled from '@emotion/styled';

export const InfoBox = styled.div<{ warning?: string; marginBottom?: number }>`
  ${(props) =>
    props.warning === 'true'
      ? `
        background: ${props.theme.color.blue.light};
        color: ${props.theme.color.blue.default};
      `
      : `
        background: ${props.theme.color.blue.light};
        border: 1px solid ${props.theme.color.blue.default};
        color: ${props.theme.color.blue.default};
      `}

  border-radius: 10px;
  display: inline-block;
  font-weight: 600;
  line-height: 1.6;
  font-size: 14px;
  margin-bottom: ${(props) => (props.marginBottom ? `${props.marginBottom}px` : '8px')};
  margin-top: 8px;
  padding: 10px;
  text-align: center;
  text-align: left;
  width: 100%;
  white-space: break-spaces;

  ul {
    list-style: disc !important;
    padding-left: 30px !important;
  }
`;
